import { Auth } from 'aws-amplify';

type RequestOptions = {
  host: string;
  path: string;
  region: string;
  service: string;
  method: RequestInit['method'];
  headers: Record<string, string>;
  body?: string;
};

let staffToken: string | null = null;

export const setStaffToken = (token: string | null) => {
  staffToken = token;
};

export const authenticate = async (request: RequestOptions) => {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();

  if (staffToken) {
    request.headers['stafftoken'] = staffToken;
  }

  if (!idToken) {
    throw new Error('No ID token found');
  }

  request.headers['authorization'] = `Bearer ${idToken}`;
};
